import logo from './logo.svg';
import './App.css';
import TitleSection from './components/Title.jsx';
import Presentation from './components/Presentation.jsx';
import Gallery from './components/Gallery.jsx'
import PngTuber from './components/PngTuber.jsx';
import Gallery2 from './components/Gallery2.jsx';
import Final from './components/Final.jsx';
import Lenis from 'lenis';
import ReactLenis from 'lenis/react';

function App() {
  return (
    <ReactLenis root>
    <div className="App">
      <TitleSection />
      <Presentation />
      <Gallery />
      <Gallery2 />
      <PngTuber />
      <Final />
    </div>
    </ReactLenis>
  );
}

export default App;
